module.exports = __webpack_public_path__ + "static/media/who-main-page-logo.e3ac1efb.svg";